import React from 'react';
import styles from './StoreTieringTable.module.css';
import { TierBadge } from './TierBadge';
import { StoreItem } from '../storeTieringTypes';

interface StoreTieringTableProps {
  items: StoreItem[];
  onRowClick: (store: StoreItem) => void;
}

const TrendCell: React.FC<{ percent: number; direction: string }> = ({ percent, direction }) => {
  if (direction === 'flat') {
    return (
      <span className={styles.trendFlat}>
        <span className={styles.trendDash}>—</span> +{percent}%
      </span>
    );
  }
  const isUp = direction === 'up';
  return (
    <span className={isUp ? styles.trendUp : styles.trendDown}>
      <svg className={styles.trendArrow} viewBox="0 0 16 16" fill="currentColor">
        {isUp ? (
          <path d="M8 4l4 4H9v4H7V8H4l4-4z"/>
        ) : (
          <path d="M8 12l-4-4h3V4h2v4h3l-4 4z"/>
        )}
      </svg>
      {percent > 0 ? '+' : ''}{percent}%
    </span>
  );
};

export const StoreTieringTable: React.FC<StoreTieringTableProps> = ({ items, onRowClick }) => {
  return (
    <div className={styles.tableWrapper}>
      <table className={styles.table}>
        <thead>
          <tr>
            <th className={styles.thStore}>STORE NAME</th>
            <th>TIER</th>
            <th className={styles.thRight}>WEEKLY REVENUE</th>
            <th className={styles.thRight}>TARGET</th>
            <th className={styles.thRight}>TREND</th>
            <th className={styles.thRight}>MARGIN</th>
            <th className={styles.thRight}>FREQUENCY</th>
            <th className={styles.thRight}>LAST ORDER</th>
          </tr>
        </thead>
        <tbody>
          {items.map((item) => {
            const isLastOrderLate = item.lastOrderDays >= 7;
            return (
              <tr
                key={item.id}
                className={styles.row}
                onClick={() => onRowClick(item)}
              >
                <td className={styles.storeCell}>
                  <span className={styles.storeName}>{item.storeName}</span>
                  <span className={styles.storeCity}>{item.city}</span>
                </td>
                <td>
                  <TierBadge tier={item.tier} />
                </td>
                <td className={styles.numericCell}>
                  ${item.weeklyRevenue.toLocaleString()}
                </td>
                <td className={styles.numericCell}>
                  {item.target ? (
                    <span className={styles.targetMet}>
                      <svg className={styles.checkIcon} viewBox="0 0 16 16" fill="currentColor">
                        <path d="M6.5 12.5l-4-4 1.4-1.4 2.6 2.6 5.6-5.6 1.4 1.4z"/>
                      </svg>
                      ${item.target.toLocaleString()}
                    </span>
                  ) : (
                    <span className={styles.noTarget}>—</span>
                  )}
                </td>
                <td className={styles.numericCell}>
                  <TrendCell percent={item.trendPercent} direction={item.trendDirection} />
                </td>
                <td className={styles.numericCell}>
                  {item.margin.toFixed(1)}%
                </td>
                <td className={styles.numericCell}>
                  {item.frequency}
                </td>
                <td className={`${styles.numericCell} ${isLastOrderLate ? styles.lastOrderLate : styles.lastOrderOk}`}>
                  {item.lastOrder}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};
